<app-page-wrapper
  [title]="(view === 'home' ? 'pluginsHomeTitle' : 'pluginsAddToolsAndPlugins') | i18n"
  [navActionInlineOnMobile]="true"
>
  <!-- phone: the + sits in the title row (on desktop "Add new" is in the toolbar below) -->
  <button
    *ngIf="view === 'home'"
    nav-action
    type="button"
    data-testid="plugins-add-new-phone"
    class="tw-hidden sm:tw-flex tw-items-center tw-justify-center tw-size-12 tw-rounded-2xl tw-bg-color-intent-brand tw-text-color-text-on-action tw-shadow-elevation-control"
    [attr.aria-label]="'pluginsAddNew' | i18n"
    (click)="showStore()"
  >
    <icon [name]="'plus'" [size]="6"></icon>
  </button>
  <!-- phone: the back arrow leads the title row, like the DS 2.1 phone header -->
  <button
    *ngIf="view === 'store'"
    title-prefix
    type="button"
    data-testid="plugins-back-phone"
    class="tw-hidden sm:tw-flex sm:tw-order-first tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-xl tw-text-color-text-secondary"
    [attr.aria-label]="'pluginsBack' | i18n"
    (click)="showHome()"
  >
    <icon [name]="'left-arrow'" [size]="6" [disableArrowOverride]="true"></icon>
  </button>
  @if (view === "home") {
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-4" data-testid="plugins-home">
      <!--      toolbar: search + add new-->
      <div class="tw-flex tw-items-center tw-gap-3 tw-w-full">
        <app-search-input
          class="tw-w-[360px] tw-max-w-full sm:tw-flex-1 sm:tw-w-auto"
          [sunken]="true"
          [iconLeading]="true"
          [clearable]="true"
          [placeholder]="'pluginsHomeSearchPlaceholder' | i18n"
          [(value)]="homeSearchQuery"
        ></app-search-input>
        <div class="tw-flex-1 sm:tw-hidden"></div>
        <button
          type="button"
          data-testid="plugins-add-new"
          [attr.aria-label]="'pluginsAddNew' | i18n"
          class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-6 tw-shrink-0 tw-rounded-2xl tw-bg-color-intent-brand tw-text-color-text-on-action tw-text-sm tw-font-semibold tw-shadow-elevation-control sm:tw-hidden"
          (click)="showStore()"
        >
          <icon [name]="'plus'" [size]="4"></icon>
          <span class="sm:tw-hidden">{{ "pluginsAddNew" | i18n }}</span>
        </button>
      </div>

      @if (homeSearch; as s) {
        <!--      search results: your tools, your plugins, then what is still in Add new-->
        <div
          class="tw-flex tw-flex-wrap tw-items-baseline tw-gap-1.5 tw-text-sm"
          data-testid="search-resline"
        >
          <b class="tw-font-bold tw-text-color-text-default">{{
            s.total === 0
              ? ("pluginsSearchNoResults" | i18n: s.query)
              : s.total === 1
                ? ("pluginsSearchResultOne" | i18n: s.query)
                : ("pluginsSearchResultMany" | i18n: s.total : s.query)
          }}</b>
          <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
            s.subKey | i18n
          }}</span>
        </div>

        @if (s.kind === "none") {
          <div
            class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-px-6 tw-py-10 tw-text-center tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
            data-testid="search-empty"
          >
            <h3 class="tw-m-0 tw-text-lg tw-font-semibold tw-text-color-text-default">
              {{ "pluginsSearchEmptyTitle" | i18n: s.query }}
            </h3>
            <p class="tw-m-0 tw-text-sm tw-text-color-text-secondary">
              {{ "pluginsSearchEmptyText" | i18n }}
            </p>
            <button
              type="button"
              class="tw-h-10 tw-px-5 tw-rounded-xl tw-bg-color-surface-card tw-text-sm tw-font-semibold tw-text-color-text-action tw-shadow-elevation-control"
              (click)="showStore()"
            >
              {{ "pluginsBrowseAddNew" | i18n }}
            </button>
          </div>
        } @else {
          @if (s.noteKey && (s.kind === "notinst" || s.kind === "mixed")) {
            <div
              class="tw-flex tw-items-center tw-gap-2 tw-text-[13px] tw-font-medium tw-text-color-text-secondary"
              data-testid="search-note"
            >
              <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
              {{ s.noteKey | i18n: s.query }}
            </div>
          }

          @if (s.tools.length) {
            <section
              class="tw-px-4 tw-py-1 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card sm:tw-p-0 sm:tw-bg-transparent sm:tw-shadow-none"
              data-testid="search-tools"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-11 tw-text-[13px] tw-font-bold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary sm:tw-h-7 sm:tw-text-xs"
              >
                {{ "pluginsYourTools" | i18n }}
                <span class="tw-font-medium tw-text-color-text-tertiary">{{ s.tools.length }}</span>
                <span
                  class="tw-ml-auto tw-text-xs tw-font-medium tw-normal-case tw-tracking-normal tw-text-color-text-tertiary sm:tw-hidden"
                  >{{ "pluginsSearchClickToOpen" | i18n }}</span
                >
              </div>
              <div
                class="sm:tw-bg-color-surface-card sm:tw-rounded-2xl sm:tw-shadow-elevation-card sm:tw-px-2"
              >
                @for (tile of s.tools; track tile.id) {
                  <button
                    type="button"
                    class="tw-flex tw-items-center tw-gap-3.5 tw-w-full tw-py-3 tw-text-left tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle sm:first:tw-border-t-0"
                    [attr.data-testid]="'search-tool-' + tile.id"
                    (click)="openTool(tile)"
                  >
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-elevated tw-shadow-elevation-control"
                    >
                      <icon
                        [name]="tile.icon"
                        [size]="6"
                        [currentColor]="'color-text-action'"
                      ></icon>
                    </span>
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                        >{{ tileLabel(tile) }}</span
                      >
                      <span class="tw-truncate tw-text-xs tw-text-color-text-tertiary">{{
                        pluginMeta(tile.plugin)
                      }}</span>
                    </span>
                    @if (badgeCount(tile) > 0) {
                      <span
                        class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-accent-today-bg tw-text-xs tw-font-semibold tw-text-color-text-action"
                        >{{ "pluginsBadgeDetected" | i18n: badgeLabel(badgeCount(tile)) }}</span
                      >
                    }
                    <span
                      class="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-color-text-action"
                    >
                      {{ "pluginsOpen" | i18n }}
                      <icon [name]="'right-arrow'" [size]="4" [disableArrowOverride]="true"></icon>
                    </span>
                  </button>
                }
              </div>
            </section>
          }

          @if (s.plugins.length) {
            <section
              class="tw-px-4 tw-py-1 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card sm:tw-p-0 sm:tw-bg-transparent sm:tw-shadow-none"
              data-testid="search-plugins"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-11 tw-text-[13px] tw-font-bold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary sm:tw-h-7 sm:tw-text-xs"
              >
                {{ "pluginsYourPlugins" | i18n }}
                <span class="tw-font-medium tw-text-color-text-tertiary">{{
                  s.plugins.length
                }}</span>
                <span
                  class="tw-ml-auto tw-text-xs tw-font-medium tw-normal-case tw-tracking-normal tw-text-color-text-tertiary sm:tw-hidden"
                  >{{ "pluginsSearchStatusAndManage" | i18n }}</span
                >
              </div>
              <div
                class="sm:tw-bg-color-surface-card sm:tw-rounded-2xl sm:tw-shadow-elevation-card sm:tw-px-2"
              >
                @for (plugin of s.plugins; track plugin.id) {
                  <div
                    class="tw-flex tw-items-center tw-gap-3.5 tw-py-3 tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle sm:first:tw-border-t-0"
                    [attr.data-testid]="'search-plugin-' + plugin.id"
                  >
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-sunken tw-text-sm tw-font-semibold tw-text-color-text-secondary"
                      >{{ plugin.title.charAt(0) }}</span
                    >
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                        >{{ plugin.title }}</span
                      >
                      <span class="tw-truncate tw-text-xs tw-text-color-text-tertiary">{{
                        pluginMeta(plugin)
                      }}</span>
                    </span>
                    <span
                      class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-status-success-bg tw-text-xs tw-font-semibold tw-text-color-status-success-text"
                      >{{ "pluginsStatusActive" | i18n }}</span
                    >
                    <button
                      type="button"
                      class="tw-h-9 tw-px-3.5 tw-rounded-xl tw-bg-color-surface-card tw-text-[13px] tw-font-semibold tw-text-color-text-action tw-shadow-elevation-control"
                      (click)="openPlugin(plugin)"
                    >
                      {{ "pluginsManage" | i18n }}
                    </button>
                  </div>
                }
              </div>
            </section>
          }

          @if (s.noteKey && (s.kind === "tools" || s.kind === "plugins")) {
            <div
              class="tw-flex tw-items-center tw-gap-2 tw-text-[13px] tw-font-medium tw-text-color-text-secondary"
              data-testid="search-note"
            >
              <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
              {{ s.noteKey | i18n: s.query }}
            </div>
          }

          @if (s.notInstalled.length) {
            <section
              class="tw-px-4 tw-py-1 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card sm:tw-p-0 sm:tw-bg-transparent sm:tw-shadow-none"
              data-testid="search-not-installed"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-h-11 tw-text-[13px] tw-font-bold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary sm:tw-h-7 sm:tw-text-xs"
              >
                {{ "pluginsSearchNotInstalled" | i18n }}
                <span class="tw-font-medium tw-text-color-text-tertiary">{{
                  s.notInstalled.length
                }}</span>
                <span
                  class="tw-ml-auto tw-text-xs tw-font-medium tw-normal-case tw-tracking-normal tw-text-color-text-tertiary sm:tw-hidden"
                  >{{ "pluginsSearchInstallHint" | i18n }}</span
                >
              </div>
              <div
                class="sm:tw-bg-color-surface-card sm:tw-rounded-2xl sm:tw-shadow-elevation-card sm:tw-px-2"
              >
                @for (plugin of s.notInstalled; track plugin.id) {
                  <div
                    role="button"
                    tabindex="0"
                    class="tw-flex tw-items-center tw-gap-3.5 tw-py-3 tw-cursor-pointer tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle sm:first:tw-border-t-0"
                    [attr.data-testid]="'search-not-installed-' + plugin.id"
                    (click)="openFromCard(plugin)"
                    (keydown.enter)="onCardKeydown(plugin, $event)"
                    (keydown.space)="onCardKeydown(plugin, $event)"
                  >
                    <span
                      class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-sunken tw-text-sm tw-font-semibold tw-text-color-text-secondary"
                      >{{ monogram(plugin) }}</span
                    >
                    <span class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                      <span
                        class="tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                        >{{ plugin.title }}</span
                      >
                      <span class="tw-truncate tw-text-xs tw-text-color-text-tertiary">{{
                        pluginMeta(plugin)
                      }}</span>
                    </span>
                    <span
                      class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-surface-sunken tw-text-xs tw-font-semibold tw-text-color-text-secondary"
                      >{{ priceLabel(plugin) }}</span
                    >
                    <button
                      type="button"
                      class="tw-h-9 tw-px-3.5 tw-rounded-xl tw-bg-color-intent-brand tw-text-[13px] tw-font-semibold tw-text-color-text-on-action tw-shadow-elevation-control"
                      (click)="openFromCard(plugin, $event)"
                    >
                      {{ "pluginsInstall" | i18n }}
                    </button>
                  </div>
                }
              </div>
            </section>
            <div>
              <button
                type="button"
                class="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-color-text-action"
                data-testid="search-see-in-add-new"
                (click)="showStore(undefined, s.query)"
              >
                {{ "pluginsSearchSeeInAddNew" | i18n: s.query }}
                <icon [name]="'right-arrow'" [size]="4" [disableArrowOverride]="true"></icon>
              </button>
            </div>
          }
        }
      } @else {
        <!--      your tools-->
        <section
          *ngIf="toolsView as tools"
          class="tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card sm:tw-p-0 sm:tw-bg-transparent sm:tw-shadow-none"
          data-testid="plugins-your-tools"
        >
          <div
            class="tw-flex tw-items-center tw-gap-2 sm:tw-sticky sm:tw-top-0 sm:tw-z-10 sm:tw-py-1.5 sm:tw-bg-color-surface-page"
            data-testid="tools-header"
          >
            <span
              class="tw-text-base tw-font-semibold tw-text-color-text-default sm:tw-text-xs sm:tw-font-bold sm:tw-uppercase sm:tw-tracking-[0.08em] sm:tw-text-color-text-secondary tw-whitespace-nowrap"
              >{{ "pluginsYourTools" | i18n }}</span
            >
            <span class="tw-text-[13px] tw-font-medium tw-text-color-text-tertiary sm:tw-text-xs">{{
              tools.visible.length
            }}</span>
            <div class="tw-flex-1"></div>
            <span
              [ngClass]="{ 'sm:tw-hidden': tools.canExpand && toolsExpanded }"
              class="tw-text-xs tw-font-medium tw-text-color-text-tertiary sm:tw-text-[11px] tw-whitespace-nowrap"
            >
              <span class="sm:tw-hidden">{{ "pluginsDragToReorder" | i18n }}</span>
              <span class="tw-hidden sm:tw-inline">{{ "pluginsHoldAndDrag" | i18n }}</span>
            </span>
            <span id="tools-reorder-hint" class="tw-sr-only">{{
              "pluginsReorderKeyboardHint" | i18n
            }}</span>
            @if (toolPrefs.order().length > 0) {
              <span
                class="tw-w-px tw-h-[14px] tw-bg-color-border-strong"
                [ngClass]="{ 'sm:tw-hidden': tools.canExpand }"
              ></span>
              <button
                type="button"
                class="tw-text-sm tw-font-semibold tw-text-color-text-action tw-whitespace-nowrap"
                [ngClass]="{ 'sm:tw-hidden': tools.canExpand && !toolsExpanded }"
                data-testid="tools-reset-order"
                (click)="resetToolOrder()"
              >
                {{ "pluginsResetOrder" | i18n }}
              </button>
            }
            <span
              class="tw-w-px tw-h-[14px] tw-bg-color-border-strong"
              [ngClass]="{
                'sm:tw-hidden': tools.canExpand && (!toolsExpanded || !toolPrefs.order().length),
              }"
            ></span>
            <button
              type="button"
              class="tw-text-sm tw-font-semibold tw-text-color-text-action tw-whitespace-nowrap"
              [ngClass]="{ 'sm:tw-hidden': tools.canExpand && !toolsExpanded }"
              data-testid="tools-edit"
              [attr.aria-label]="'pluginsEditYourTools' | i18n"
              (click)="openEditTools()"
            >
              {{ "pluginsEditTools" | i18n }}
            </button>
            @if (tools.canExpand) {
              <span class="tw-w-px tw-h-[14px] tw-bg-color-border-strong"></span>
              <button
                type="button"
                class="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-color-text-action tw-whitespace-nowrap"
                data-testid="tools-show-all"
                [attr.aria-expanded]="toolsExpanded"
                (click)="toggleToolsExpanded()"
              >
                <span>{{
                  toolsExpanded
                    ? ("pluginsShowLess" | i18n)
                    : ("pluginsShowAll" | i18n: tools.visible.length)
                }}</span>
                <icon
                  [name]="'chevron-down'"
                  [size]="4"
                  [ngClass]="{ 'tw-rotate-180': toolsExpanded }"
                ></icon>
              </button>
            }
          </div>
          <span class="tw-sr-only" role="status" aria-live="polite">{{
            toolReorderAnnouncement
          }}</span>
          <!-- Count badge on a tile's top right; hidden from screen readers (the count is read via the
             tile's sr-only text instead). -->
          <ng-template #toolBadge let-count>
            @if (count > 0) {
              <span
                aria-hidden="true"
                class="tw-absolute tw-left-[42px] -tw-top-1.5 tw-flex tw-items-center tw-justify-center tw-h-5 tw-px-1.5 tw-rounded-full tw-border-2 tw-border-solid tw-border-color-surface-elevated tw-bg-color-intent-brand tw-text-[10px] tw-font-semibold tw-leading-[14px] tw-text-color-text-on-action"
                data-testid="tool-badge"
                >{{ badgeLabel(count) }}</span
              >
            }
          </ng-template>
          <div
            #toolsGrid
            *ngIf="toolPrefsReady"
            class="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-x-1.5 sm:tw-gap-y-2.5"
            cdkDropList
            cdkDropListOrientation="mixed"
            data-testid="tools-grid"
            (cdkDropListDropped)="onToolDrop($event)"
          >
            @for (tile of tools.displayed; track tile.id; let i = $index) {
              <button
                type="button"
                cdkDrag
                [cdkDragData]="tile"
                [cdkDragStartDelay]="{ touch: 300, mouse: 0 }"
                class="tw-flex tw-flex-col tw-items-center tw-gap-[9px] tw-w-[134px] tw-shrink-0 tw-cursor-grab active:tw-cursor-grabbing [&.cdk-drag-animating]:tw-transition-transform [&.cdk-drag-animating]:tw-duration-200 sm:tw-w-auto sm:tw-gap-[7px] sm:tw-min-w-0"
                [attr.data-testid]="'tool-tile-' + tile.id"
                aria-keyshortcuts="Alt+ArrowLeft Alt+ArrowRight"
                aria-describedby="tools-reorder-hint"
                (click)="openTool(tile)"
                (keydown)="onToolKeydown($event, i)"
              >
                <!-- Dashed slot marking where the tile will land; same footprint as a tile so
                   neighbours shift out of the way instead of overlapping it. -->
                <div
                  *cdkDragPlaceholder
                  class="tw-w-[134px] tw-min-h-[81px] tw-self-stretch tw-shrink-0 tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-color-border-strong"
                ></div>
                <!-- Floating copy that follows the pointer, kept above the grid. -->
                <ng-template cdkDragPreview [matchSize]="true">
                  <div
                    class="tw-flex tw-flex-col tw-items-center tw-gap-[9px] tw-w-full tw-cursor-grabbing tw-pointer-events-none"
                  >
                    <span
                      class="tw-relative tw-flex tw-items-center tw-justify-center tw-size-14 tw-rounded-[18px] tw-bg-color-surface-elevated tw-shadow-elevation-card"
                    >
                      <icon
                        [name]="tile.icon"
                        [size]="6"
                        [currentColor]="'color-text-action'"
                      ></icon>
                      <ng-container
                        *ngTemplateOutlet="toolBadge; context: { $implicit: badgeCount(tile) }"
                      ></ng-container>
                    </span>
                    <span
                      class="tw-text-xs tw-font-medium tw-text-center tw-text-color-text-default"
                      >{{ tileLabel(tile) }}</span
                    >
                  </div>
                </ng-template>
                <span
                  class="tw-relative tw-flex tw-items-center tw-justify-center tw-size-14 tw-rounded-[18px] tw-bg-color-surface-elevated tw-shadow-elevation-control sm:tw-size-[52px] sm:tw-rounded-2xl"
                >
                  <icon [name]="tile.icon" [size]="6" [currentColor]="'color-text-action'"></icon>
                  <ng-container
                    *ngTemplateOutlet="toolBadge; context: { $implicit: badgeCount(tile) }"
                  ></ng-container>
                </span>
                <span
                  class="tw-text-xs tw-font-medium tw-text-center tw-text-color-text-default sm:tw-text-[11.5px] sm:tw-leading-[14px] sm:tw-line-clamp-2 sm:tw-min-h-[28px]"
                  >{{ tileLabel(tile) }}</span
                >
                @if (badgeCount(tile) > 0) {
                  <span class="tw-sr-only">{{ badgeLabel(badgeCount(tile)) }}</span>
                }
              </button>
            }
            @if (showAddToolTile) {
              <button
                type="button"
                class="tw-flex tw-flex-col tw-items-center tw-gap-[9px] tw-w-[134px] sm:tw-w-auto sm:tw-gap-[7px]"
                data-testid="tool-tile-add"
                (click)="showStore()"
              >
                <span
                  class="tw-flex tw-items-center tw-justify-center tw-size-14 tw-rounded-2xl tw-bg-color-surface-sunken sm:tw-size-[52px]"
                >
                  <icon [name]="'plus'" [size]="6" [currentColor]="'color-text-action'"></icon>
                </span>
                <span
                  class="tw-text-xs tw-font-medium tw-text-center tw-text-color-text-action sm:tw-text-[11.5px]"
                  >{{ "pluginsAddATool" | i18n }}</span
                >
              </button>
            }
          </div>
        </section>

        <!--      plugins-->
        <section
          class="tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-rounded-2xl tw-bg-white/40 sm:tw-p-0 sm:tw-bg-transparent"
          data-testid="plugins-section"
        >
          <div class="tw-flex tw-items-center tw-gap-2 tw-px-1">
            <span
              class="tw-text-base tw-font-semibold tw-text-color-text-default sm:tw-text-xs sm:tw-font-bold sm:tw-uppercase sm:tw-tracking-[0.08em] sm:tw-text-color-text-secondary"
              >{{ "pluginsSectionTitle" | i18n }}</span
            >
            <span class="tw-text-[13px] tw-font-medium tw-text-color-text-tertiary sm:tw-text-xs">{{
              installedPluginCards.length
            }}</span>
          </div>
          <div class="tw-flex tw-flex-wrap tw-gap-6 sm:tw-grid sm:tw-grid-cols-2 sm:tw-gap-4">
            @for (plugin of installedPluginCards; track plugin.id) {
              <button
                type="button"
                class="tw-flex tw-flex-col tw-gap-4 tw-p-5 tw-w-[264px] tw-text-left tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card sm:tw-grid sm:tw-grid-cols-[1fr_auto] sm:tw-gap-2 sm:tw-p-3 sm:tw-w-auto sm:tw-min-w-0"
                [attr.data-testid]="'plugin-card-' + plugin.id"
                (click)="openPlugin(plugin)"
              >
                <div class="tw-flex tw-items-center tw-w-full sm:tw-contents">
                  <span
                    class="tw-flex tw-items-center tw-justify-center tw-size-12 tw-shrink-0 tw-rounded-2xl tw-bg-color-surface-sunken tw-text-base tw-font-semibold tw-text-color-text-secondary sm:tw-size-10 sm:tw-rounded-xl sm:tw-col-start-1 sm:tw-row-start-1 sm:tw-text-sm"
                    >{{ plugin.title.charAt(0) }}</span
                  >
                  <span class="tw-flex-1 sm:tw-hidden"></span>
                  <span
                    class="tw-flex tw-items-center tw-justify-center tw-h-7 tw-min-w-[60px] tw-px-3 tw-rounded-full tw-bg-color-status-success-bg tw-text-[13px] tw-font-medium tw-text-color-status-success-text sm:tw-col-span-2 sm:tw-row-start-3 sm:tw-justify-self-start sm:tw-h-[26px] sm:tw-min-w-0 sm:tw-px-2.5 sm:tw-text-xs"
                    >{{ "pluginsStatusActive" | i18n }}</span
                  >
                </div>
                <div class="tw-flex tw-items-center tw-gap-2 tw-w-full sm:tw-contents">
                  <div
                    class="tw-flex tw-flex-col tw-gap-0.5 tw-flex-1 tw-min-w-0 sm:tw-col-span-2 sm:tw-row-start-2"
                  >
                    <span
                      class="tw-truncate tw-text-base tw-font-semibold tw-text-color-text-default sm:tw-text-sm sm:tw-leading-5"
                      >{{ plugin.title }}</span
                    >
                    <span
                      class="tw-truncate tw-text-[13px] tw-font-medium tw-text-color-text-tertiary sm:tw-hidden"
                      >{{ plugin.type ? plugin.type + " · " + plugin.author : plugin.author }}</span
                    >
                  </div>
                  <icon
                    class="sm:tw-col-start-2 sm:tw-row-start-1 sm:tw-self-start"
                    [name]="'right-arrow'"
                    [size]="5"
                    [currentColor]="'color-text-tertiary'"
                    [disableArrowOverride]="true"
                  ></icon>
                </div>
              </button>
            }
            <button
              type="button"
              class="tw-flex tw-items-center tw-gap-3 tw-px-5 tw-h-[148px] tw-w-[264px] tw-text-left tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-color-border-strong sm:tw-col-span-2 sm:tw-w-auto sm:tw-h-auto sm:tw-py-4"
              data-testid="plugin-card-add"
              (click)="showStore()"
            >
              <span
                class="tw-flex tw-items-center tw-justify-center tw-size-12 tw-shrink-0 tw-rounded-2xl tw-bg-color-surface-sunken"
              >
                <icon [name]="'plus'" [size]="6" [currentColor]="'color-text-action'"></icon>
              </span>
              <span class="tw-flex tw-flex-col tw-gap-0.5 tw-flex-1 tw-min-w-0">
                <span class="tw-text-base tw-font-semibold tw-text-color-text-action">{{
                  "pluginsAddAPlugin" | i18n
                }}</span>
                <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
                  "pluginsAddAPluginHint" | i18n
                }}</span>
              </span>
            </button>
          </div>
        </section>
      }
    </div>
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full sm:tw-px-4" data-testid="plugins-store">
      <!--      back + subtitle-->
      <div class="tw-flex tw-items-center tw-gap-4 sm:tw-hidden">
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-xl tw-text-color-text-secondary"
          data-testid="plugins-back"
          [attr.aria-label]="'pluginsBack' | i18n"
          (click)="showHome()"
        >
          <icon [name]="'left-arrow'" [size]="6" [disableArrowOverride]="true"></icon>
        </button>
        <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
          "pluginsCatalogueSubtitle" | i18n: totalCount
        }}</span>
      </div>

      <div
        class="tw-grid tw-grid-cols-[240px_minmax(0,1fr)] tw-gap-4 tw-items-start lg:tw-grid-cols-1 sm:tw-flex sm:tw-flex-col sm:tw-items-stretch sm:tw-gap-3"
      >
        <!--      left column: tabs, filters, missing (stacks above the results below lg; on a phone its children join the page flow)-->
        <div class="tw-flex tw-flex-col tw-gap-4 sm:tw-contents">
          <div
            class="tw-flex tw-gap-0.5 tw-p-1 tw-rounded-xl tw-bg-color-surface-sunken tw-shadow-elevation-input sm:tw-order-2"
            role="tablist"
            [attr.aria-label]="'pluginsCatalogueTabs' | i18n"
          >
            @for (tab of ["store", "wishlist"]; track tab) {
              <button
                type="button"
                role="tab"
                class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-1.5 tw-h-8 tw-px-4 tw-rounded-[9px] tw-text-[13px] tw-font-semibold"
                [ngClass]="
                  selectedTab === tab
                    ? 'tw-bg-color-surface-elevated tw-shadow-elevation-control tw-text-color-text-default'
                    : 'tw-text-color-text-secondary'
                "
                [attr.aria-selected]="selectedTab === tab"
                aria-controls="plugins-results"
                [attr.data-testid]="'store-tab-' + tab"
                [id]="'plugins-tab-' + tab"
                (click)="selectedTab = $any(tab)"
              >
                <span>{{ (tab === "store" ? "pluginTabAll" : "pluginTabSaved") | i18n }}</span>
                <span class="tw-font-medium tw-text-color-text-tertiary">{{
                  tab === "store" ? browsableCount : savedCount
                }}</span>
              </button>
            }
          </div>

          <div
            [ngClass]="{ 'sm:tw-hidden': !phoneFilter }"
            class="sm:tw-order-4 tw-flex tw-flex-col tw-gap-1.5 tw-p-4 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
            data-testid="plugins-filters"
          >
            <div class="tw-flex tw-items-center tw-justify-between tw-pb-1.5">
              <span class="tw-text-[15px] tw-font-semibold tw-text-color-text-default">{{
                "pluginsFilters" | i18n
              }}</span>
              <button
                type="button"
                class="tw-text-[13px] tw-font-semibold"
                [ngClass]="
                  canClearFilters
                    ? 'tw-text-color-text-action'
                    : 'tw-text-color-text-tertiary tw-cursor-default'
                "
                [disabled]="!canClearFilters"
                data-testid="plugins-clear-filters"
                (click)="clearFilter()"
              >
                {{ "clearAll" | i18n }}
              </button>
            </div>

            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="group"
              aria-labelledby="pluginsFilterType-label"
              [ngClass]="{ 'sm:tw-hidden': phoneFilter && phoneFilter !== 'type' }"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterType-label"
                >{{ "pluginsFilterType" | i18n }}</span
              >
              @for (opt of typeOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.label,
                      count: typeCount(opt.id),
                      on: activeTypes.includes(opt.id),
                      radio: false,
                      group: 'type',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="radiogroup"
              aria-labelledby="pluginsFilterCategory-label"
              [ngClass]="{ 'sm:tw-hidden': phoneFilter && phoneFilter !== 'category' }"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterCategory-label"
                >{{ "pluginsFilterCategory" | i18n }}</span
              >
              @for (opt of categoryOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.id === allCategories ? ('pluginsAllCategories' | i18n) : opt.id,
                      count: opt.count,
                      on: activeCategory === opt.id,
                      radio: true,
                      group: 'category',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
            <div
              class="tw-flex tw-flex-col tw-gap-1.5"
              role="group"
              aria-labelledby="pluginsFilterPrice-label"
              [ngClass]="{ 'sm:tw-hidden': phoneFilter && phoneFilter !== 'price' }"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterPrice-label"
                >{{ "pluginsFilterPrice" | i18n }}</span
              >
              @for (opt of bundleOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.label,
                      count: priceCount(opt.id),
                      on: activeBundles.includes(opt.id),
                      radio: false,
                      group: 'bundle',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
            <!-- Country has no phone chip (Type / Category / Price only), so it stays desktop-only -->
            <div
              class="tw-flex tw-flex-col tw-gap-1.5 sm:tw-hidden"
              role="group"
              aria-labelledby="pluginsFilterCountry-label"
            >
              <span
                class="tw-pt-2.5 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
                id="pluginsFilterCountry-label"
                >{{ "pluginsFilterCountry" | i18n }}</span
              >
              @for (opt of countryOptions; track opt.id) {
                <ng-container
                  *ngTemplateOutlet="
                    filterOption;
                    context: {
                      label: opt.label,
                      count: countryCount(opt.id),
                      on: activeCountries.includes(opt.id),
                      radio: false,
                      group: 'country',
                      id: opt.id,
                    }
                  "
                ></ng-container>
              }
            </div>
          </div>

          <div
            class="tw-flex tw-flex-col tw-gap-1.5 tw-p-4 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card tw-text-[13px] tw-text-color-text-secondary sm:tw-hidden"
          >
            <span class="tw-text-[15px] tw-font-semibold tw-text-color-text-default">{{
              "pluginsMissingTitle" | i18n
            }}</span>
            <span>{{ "pluginsMissingBody" | i18n }}</span>
          </div>
        </div>

        <!--      phone: one filter row of dropdown chips (the filter card opens under it)-->
        <div
          class="tw-hidden sm:tw-flex sm:tw-order-3 tw-flex-wrap tw-gap-2"
          data-testid="plugins-filter-chips"
        >
          @for (chip of phoneFilterChips; track chip.id) {
            <button
              type="button"
              class="tw-flex tw-items-center tw-gap-1.5 tw-h-9 tw-px-3.5 tw-rounded-full tw-text-[13px] tw-shadow-elevation-control"
              [ngClass]="
                phoneFilter === chip.id
                  ? 'tw-bg-color-surface-elevated tw-font-semibold tw-text-color-text-default'
                  : 'tw-bg-color-surface-card tw-font-medium tw-text-color-text-secondary'
              "
              [attr.aria-expanded]="phoneFilter === chip.id"
              [attr.data-testid]="'filter-chip-' + chip.id"
              (click)="togglePhoneFilter(chip.id)"
            >
              {{ chip.labelKey | i18n }}
              <icon
                [name]="'chevron-down'"
                [size]="3.5"
                [ngClass]="{ 'tw-rotate-180': phoneFilter === chip.id }"
              ></icon>
            </button>
          }
        </div>

        <!--      right column: search, results-->
        <div
          class="tw-flex tw-flex-col tw-gap-3.5 tw-min-w-0 sm:tw-contents"
          id="plugins-results"
          role="tabpanel"
          [attr.aria-labelledby]="'plugins-tab-' + selectedTab"
        >
          <app-search-input
            class="sm:tw-order-1"
            [sunken]="true"
            [iconLeading]="true"
            [clearable]="true"
            [placeholder]="'searchPlugins' | i18n"
            [(value)]="searchQuery"
          ></app-search-input>

          <div class="tw-flex tw-flex-wrap tw-items-baseline tw-gap-1.5 tw-text-sm sm:tw-order-5">
            <span class="tw-font-bold tw-text-color-text-default">{{
              "pluginsResultsCount" | i18n: displayedPlugins.length
            }}</span>
            @if (searchQuery.trim()) {
              <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
                "pluginsResultsFor" | i18n: searchQuery.trim()
              }}</span>
            }
          </div>

          @if (showInstalledNote) {
            <div
              class="tw-flex tw-items-center tw-gap-2 tw-text-[13px] tw-font-medium tw-text-color-text-secondary sm:tw-order-5"
              data-testid="installed-plugins-note"
            >
              <icon [name]="'info-circle'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
              <span class="tw-flex-1">{{
                (hiddenInstalledPluginCount === 1
                  ? "pluginsInstalledNoteOne"
                  : "pluginsInstalledNoteMany"
                ) | i18n: hiddenInstalledPluginCount
              }}</span>
              <button
                type="button"
                class="tw-flex tw-items-center tw-gap-1 tw-shrink-0 tw-text-[13px] tw-font-semibold tw-text-color-text-action"
                data-testid="installed-plugins-manage"
                (click)="showHome()"
              >
                <span class="sm:tw-hidden">{{ "pluginsInstalledNoteManageLong" | i18n }}</span>
                <span class="tw-hidden sm:tw-inline">{{
                  "pluginsInstalledNoteManage" | i18n
                }}</span>
              </button>
            </div>
          }

          @if (displayedPlugins.length > 0) {
            <div
              class="tw-grid tw-grid-cols-3 tw-gap-4 xl:tw-grid-cols-2 md:tw-grid-cols-1 sm:!tw-grid-cols-1 sm:tw-order-6 sm:tw-gap-3"
            >
              @for (plugin of displayedPlugins; track plugin.id) {
                <!-- Mouse: the whole card opens details. Keyboard: the title button does, so the card holds no nested interactive roles. -->
                <div
                  class="tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-min-w-0 tw-text-left tw-cursor-pointer tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card sm:tw-grid sm:tw-grid-cols-[auto_minmax(0,1fr)_auto_auto] sm:tw-gap-x-3 sm:tw-gap-y-0.5 sm:tw-p-3"
                  [attr.data-testid]="'catalogue-card-' + plugin.id"
                  (click)="openFromCard(plugin)"
                >
                  <div class="tw-flex tw-items-start tw-gap-3 tw-min-w-0 sm:tw-contents">
                    <span
                      class="sm:tw-col-start-1 sm:tw-row-start-1 sm:tw-row-span-2 sm:tw-self-center tw-flex tw-items-center tw-justify-center tw-size-10 tw-shrink-0 tw-rounded-xl tw-bg-color-surface-sunken tw-text-[13px] tw-font-semibold tw-text-color-text-secondary"
                      >{{ monogram(plugin) }}</span
                    >
                    <span
                      class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0 sm:tw-col-start-2 sm:tw-row-start-1"
                    >
                      <button
                        type="button"
                        class="tw-truncate tw-text-left tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-color-text-default"
                        [attr.data-testid]="'catalogue-open-' + plugin.id"
                        (click)="openFromCard(plugin, $event)"
                      >
                        {{ plugin.title }}
                      </button>
                      <span
                        class="tw-truncate tw-text-xs tw-leading-4 tw-text-color-text-tertiary sm:tw-hidden"
                        >{{ pluginMeta(plugin) }}</span
                      >
                      <span
                        class="tw-hidden sm:tw-block tw-truncate tw-text-xs tw-leading-4 tw-text-color-text-tertiary"
                        >{{ pluginMeta(plugin) }} · {{ priceLabel(plugin) }}</span
                      >
                    </span>
                    <button
                      type="button"
                      class="tw-flex tw-items-center tw-justify-center tw-size-7 tw-shrink-0 tw-rounded-lg sm:tw-col-start-3 sm:tw-row-start-1 sm:tw-self-start"
                      [attr.aria-pressed]="!!plugin.isLiked"
                      [attr.aria-label]="
                        (plugin.isLiked ? 'pluginsRemoveFromSaved' : 'pluginsSaveForLater') | i18n
                      "
                      (click)="toggleSaved(plugin, $event)"
                    >
                      <icon
                        [name]="plugin.isLiked ? 'bookmark-on' : 'bookmark'"
                        [size]="5"
                        [currentColor]="
                          plugin.isLiked ? 'color-text-action' : 'color-text-tertiary'
                        "
                      ></icon>
                    </button>
                  </div>
                  <span
                    class="tw-line-clamp-2 tw-min-h-[38px] tw-text-[13px] tw-leading-[19px] tw-text-color-text-secondary sm:tw-col-start-2 sm:tw-row-start-2 sm:tw-line-clamp-1 sm:tw-min-h-0 sm:tw-text-xs"
                    >{{ plugin.description }}</span
                  >
                  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 sm:tw-contents">
                    <span
                      class="sm:tw-hidden tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-text-xs tw-font-semibold tw-whitespace-nowrap tw-min-w-0 tw-truncate"
                      [ngClass]="
                        isPluginInstalled(plugin.id)
                          ? 'tw-bg-color-status-success-bg tw-text-color-status-success-text'
                          : 'tw-bg-color-surface-sunken tw-text-color-text-secondary'
                      "
                      >{{
                        isPluginInstalled(plugin.id)
                          ? ("pluginsInstalled" | i18n)
                          : priceLabel(plugin)
                      }}</span
                    >
                    <button
                      type="button"
                      class="tw-flex tw-items-center tw-justify-center tw-h-9 tw-px-3.5 tw-shrink-0 tw-rounded-xl tw-text-[13px] tw-font-semibold tw-shadow-elevation-control sm:tw-col-start-4 sm:tw-row-start-1 sm:tw-row-span-2 sm:tw-self-center"
                      [ngClass]="
                        isPluginInstalled(plugin.id)
                          ? 'tw-bg-color-surface-card tw-text-color-text-action'
                          : 'tw-bg-color-intent-brand tw-text-color-text-on-action'
                      "
                      (click)="onCatalogueAction(plugin, $event)"
                    >
                      {{ (isPluginInstalled(plugin.id) ? "pluginsOpen" : "pluginsInstall") | i18n }}
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div
              class="sm:tw-order-6 tw-flex tw-items-center tw-justify-center tw-p-12 tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
            >
              <span class="tw-text-color-text-tertiary tw-text-base">
                @if (noFilterOptionSelected) {
                  {{ "pluginFilterSelectOption" | i18n }}
                } @else if (searchQuery && searchQuery.trim() !== "") {
                  {{ "noPluginsFoundMatching" | i18n: searchQuery }}
                } @else if (selectedTab === "wishlist") {
                  {{ "pluginsNoSaved" | i18n }}
                } @else {
                  {{ "noPluginsAvailable" | i18n }}
                }
              </span>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- one row of the Filters card: checkbox (or radio for Category) + label + count -->
    <ng-template
      #filterOption
      let-label="label"
      let-count="count"
      let-on="on"
      let-radio="radio"
      let-group="group"
      let-id="id"
    >
      <button
        type="button"
        class="tw-flex tw-items-center tw-gap-2.5 tw-w-full tw-h-9 tw-px-2 tw-rounded-[10px] tw-text-sm tw-text-left"
        [ngClass]="
          on
            ? 'tw-bg-color-surface-elevated tw-shadow-elevation-control tw-font-semibold tw-text-color-text-default'
            : 'tw-text-color-text-secondary'
        "
        [attr.role]="radio ? 'radio' : 'checkbox'"
        [attr.aria-checked]="on"
        (click)="toggleOption(group, id)"
      >
        <span
          class="tw-flex tw-items-center tw-justify-center tw-size-5 tw-shrink-0 tw-text-white"
          [ngClass]="[
            radio ? 'tw-rounded-full' : 'tw-rounded-[5px]',
            on
              ? 'tw-bg-color-intent-brand'
              : 'tw-bg-color-surface-sunken tw-shadow-elevation-input',
          ]"
        >
          @if (on) {
            <icon [name]="'check-only'" [size]="3.5" [disableArrowOverride]="true"></icon>
          }
        </span>
        <span class="tw-flex-1 tw-truncate">{{ label }}</span>
        <span class="tw-text-xs tw-font-normal tw-text-color-text-tertiary">{{ count }}</span>
      </button>
    </ng-template>
  }
</app-page-wrapper>
